import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import _ from 'lodash';
import VueMarkdown from 'vue-markdown';
import BackButton from '@/components/BackButton.vue';
const powersModule = namespace('powers');
let CharactersForcePowers = class CharactersForcePowers extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = 'Force Powers';
    }
    created() {
        this.fetchPowers();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        return _(this.powers)
            .filter(({ powerType }) => powerType === 'Force')
            .map(powers => ({
            ...powers,
            id: powers.name,
            isExpandable: powers.description
        })).value();
    }
    get headers() {
        return [
            { text: 'Name', value: 'name' },
            {
                text: 'Level',
                value: 'level',
                render: (value) => value || 'At-will',
                isMultiSelect: true,
                filterChoices: ['At-will', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
                filterFunction: ({ level }, filterValue) => _.includes(filterValue, (level || 'At-will').toString())
            },
            {
                text: 'Force Alignment',
                value: 'forceAlignment',
                isMultiSelect: true,
                filterChoices: ['Dark', 'Light', 'Universal'],
                filterFunction: ({ forceAlignment }, filterValue) => _.includes(filterValue, forceAlignment)
            },
            {
                text: 'Casting Period',
                value: 'castingPeriodText',
                isMultiSelect: true,
                filterChoices: ['1 action', '1 bonus action', '1 reaction', '1 hour', '8 hours', '1 minute', '10 minutes'],
                filterFunction: ({ castingPeriodText }, filterValue) => _.some(filterValue, (filter) => _.includes(castingPeriodText, filter))
            },
            {
                text: 'Range',
                value: 'range',
                isMultiSelect: true,
                filterChoices: ['Varies', 'Self', 'Touch', '10 feet', '15 feet', '30 feet', '60 feet', '90 feet', '100 feet', '120 feet', '150 feet', '250 feet', '300 feet', '500 feet', 'Unlimited'],
                filterFunction: ({ range }, filterValue) => _.some(filterValue, (filter) => range.includes(filter))
            },
            {
                text: 'Duration',
                value: 'duration',
                render: _.upperFirst,
                isMultiSelect: true,
                filterChoices: ['1 hour', '1 minute', '10 minutes', '24 hours', '8 hours', 'Instantaneous'],
                filterFunction: ({ duration }, filterValue) => _.some(filterValue, (filter) => _.includes(duration, filter))
            },
            {
                text: 'Concentration',
                value: 'concentration',
                render: (value) => value ? 'Concentration' : '-',
                filterChoices: ['No', 'Yes'],
                filterFunction: ({ concentration }, filterValue) => {
                    if (concentration && filterValue === 'Yes')
                        return true;
                    if (!concentration && filterValue === 'No')
                        return true;
                    return false;
                }
            },
            { text: 'Prerequisite', value: 'prerequisite', render: (value) => value || '-' },
            {
                text: 'Source',
                value: 'contentSource',
                render: _.startCase,
                filterChoices: ['PHB', 'EC'],
                filterFunction: ({ contentSource }, filterValue) => _.startCase(contentSource) === filterValue
            }
        ];
    }
};
__decorate([
    powersModule.State
], CharactersForcePowers.prototype, "powers", void 0);
__decorate([
    powersModule.Action
], CharactersForcePowers.prototype, "fetchPowers", void 0);
CharactersForcePowers = __decorate([
    Component({
        components: {
            SearchTable,
            BackButton,
            VueMarkdown
        }
    })
], CharactersForcePowers);
export default CharactersForcePowers;
